import { render } from "./RetrievePasswordTwo.vue?vue&type=template&id=0ad6e29f"
import script from "./RetrievePasswordTwo.vue?vue&type=script&lang=js"
export * from "./RetrievePasswordTwo.vue?vue&type=script&lang=js"

import "./RetrievePasswordTwo.vue?vue&type=style&index=0&id=0ad6e29f&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__